module.exports = __webpack_public_path__ + "148de921897066d0f2146606bb7d97ee.svg";